/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';

export const setQuickstartButtonRef =
	(quickstartButtonRef: HTMLElement | null): Action<State> =>
	({ setState }) => {
		setState({ quickstartButtonRef });
	};

export const setIsOpenedViaButton =
	(isOpenedViaButton: boolean): Action<State> =>
	({ setState }) => {
		setState({ isOpenedViaButton });
	};

// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const MAX_FOCUS_RETRIES = 15;

export const focusQuickstartButton =
	(): Action<State> =>
	({ setState, getState }) => {
		let retryCount = 0;

		const tryFocus = () => {
			const { quickstartButtonRef, isOpenedViaButton } = getState();

			if (quickstartButtonRef && isOpenedViaButton) {
				quickstartButtonRef.focus({ preventScroll: true });
				setState({ isOpenedViaButton: false });
			} else if (!quickstartButtonRef && retryCount < MAX_FOCUS_RETRIES) {
				// If ref not available yet due to button animation delay, try again
				retryCount++;
				requestAnimationFrame(tryFocus);
			}
		};

		// Uses requestAnimationFrame to wait until the ref is available
		requestAnimationFrame(tryFocus);
	};
